import { render, staticRenderFns } from "./OneToOneChat.vue?vue&type=template&id=7b45cd5e"
import script from "./OneToOneChat.vue?vue&type=script&lang=ts"
export * from "./OneToOneChat.vue?vue&type=script&lang=ts"
import style0 from "./OneToOneChat.vue?vue&type=style&index=0&id=7b45cd5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports